import axios from 'axios';


export const  axios_clients_searchclientbyid = async (idlead)=>{
    return  await  axios.post(`/clients/searchclientbyid`,{'id' :idlead },{headers:{ 'Accept': 'application/json','Content-Type':'application/json'}});
}

export const  axios_clients_updateclients = async (lead)=>{
    return  await  axios.post(`/clients/updateclients`,lead );
}

export const  axios_clients_commercialchange = async ({idlead,commercial_new})=>{
    return  await  axios.post(`/clients/commercialchange`,{idlead,commercial_new} );
}

export const  axios_clients_delete = async (listidsuppression)=>{
    return await axios.post(`/clients/delete/`,{listidsuppression});
}

export const  axios_clients_updateemail = async ({email,newemail,courtier})=>{
    return await axios.post(`/clients/updateemail`,{email,newemail,courtier},{headers:{ 'Accept': 'application/json','Content-Type':'application/json'}});
}

export const  axios_clients_statutchange = async ({id_lead,newstatus})=>{
    return await axios.post(`/clients/statutchange/`,{id_lead,newstatus});
}


// DEV
export const  axios_clients_findnontraites= async ()=>{
    return await axios.post(`/clients/findnontraites`,{},{headers:{ 'Accept': 'application/json','Content-Type':'application/json'}});
}

export const  axios_clients_findclients= async ()=>{
    return await axios.post(`/clients/findclients`,{},{headers:{ 'Accept': 'application/json','Content-Type':'application/json'}});
}

// FIN DEV




export const  axios_clients_findcustomclients= async (allfiltres)=>{
    return await axios.post(`/clients/findcustomclients`,allfiltres,{headers:{ 'Accept': 'application/json','Content-Type':'application/json'}});

}

let actucontroller = null;
export const  axios_clients_searchclient= async (data)=>{
    actucontroller && actucontroller.abort() ;
    const controller = new AbortController();
    actucontroller = controller ;
    return  await axios.post(`/clients/searchclient/`,{data},{signal: controller.signal},{headers:{ 'Accept': 'application/json','Content-Type':'application/json'}}); ;
}

export const  axios_clients_createclient= async (lead)=>{
    return await axios.post(`/clients/createclient/`,lead  );
}

export const  axios_clients_searchclientbytel= async ({numtel,commercial,courtier})=>{ 
    return await axios.post(`/clients/searchclientbytel/`, {numtel,commercial,courtier} , { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
}